import type { CardKind, Team } from '../shared/types';

export const partyAsset = (name: string) => `/art/c-v1/${name}.webp`;
export function PawnArt({ team, className = '' }: { team: Team; className?: string }) {
  return <img className={`pawn-art ${className}`} src={partyAsset(team === 'A' ? 'pawn-sun' : 'pawn-moon')} alt="" draggable={false} />;
}
export function CardArt({ card, className = '' }: { card: CardKind; className?: string }) {
  return <img className={`card-art ${className}`} src={partyAsset(`card-${card}`)} alt="" loading="lazy" draggable={false} />;
}
